(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-description-block"] && !Shopify.designMode) return;
  try {
    (() => {
  const selector = '.product-page .accordion__title, .product-page .product-tabs-title button, .product-page .product__title, .product-page .accordion__body tr > :first-child, .product-page .tab-content tr > :first-child, .product-page .product__block__description tr > :first-child, .product-page .accordion__body :is(h2,h3,h4), .product-page .tab-content :is(h2,h3,h4)';
  const cleanLabels = () => {
    document.querySelectorAll(selector).forEach(element => {
      if (!/:\s*$/.test(element.textContent)) return;
      const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
      let last;
      while (walker.nextNode()) {
        if (walker.currentNode.textContent.trim()) last = walker.currentNode;
      }
      if (last) last.textContent = last.textContent.replace(/:\s*$/, '');
    });
  };
  const simplifyDetails = () => {
    const normalize = value => value.toLowerCase().replace(/&amp;/g, '&').replace(/[^\p{L}\p{N}]/gu, '');
    document.querySelectorAll('.product-page .product__block__description').forEach(root => {
      const title = root.dataset.catalogueTitle || '';
      const titleParts = title.split('|').map(part => part.trim());
      const brand = document.querySelector('.product-page .tos-product__brand')?.textContent || titleParts[0];
      const names = [title, titleParts.slice(1).join(' '), titleParts[1] || '', document.querySelector('.product-page h1')?.textContent || ''].map(normalize);
      root.querySelectorAll('tr').forEach(row => {
        if (row.cells.length !== 2) return;
        const label = row.cells[0].textContent.trim().replace(/:$/, '').toLowerCase();
        const cell = row.cells[1];
        const value = normalize(cell.textContent);
        if (['brand', 'designer', 'artist', 'maker'].includes(label) && value === normalize(brand)) row.remove();
        else if (label === 'product' && value && names.includes(value)) row.remove();
        else if (/dimension|measurement/.test(label)) {
          const walker = document.createTreeWalker(cell, NodeFilter.SHOW_TEXT);
          const nodes = [];
          while (walker.nextNode()) nodes.push(walker.currentNode);
          nodes.forEach(node => {
            const match = node.textContent.match(/^(.*?\bcm)\s*[|/]\s*(.+?\b(?:in|inch|inches)\b.*)$/i);
            if (!match) return;
            node.replaceWith(document.createTextNode(match[1]), document.createElement('br'), document.createTextNode(match[2]));
          });
        }
      });
    });
  };
  const start = () => {
    const root = document.querySelector('.product-page');
    if (!root) return;
    cleanLabels();
    simplifyDetails();
    const observer = new MutationObserver(() => {
      observer.disconnect();
      cleanLabels();
    simplifyDetails();
      observer.observe(root, { childList: true, subtree: true, characterData: true });
    });
    observer.observe(root, { childList: true, subtree: true, characterData: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', cleanLabels);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tos-conversation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tos-conversation')) {
  customElements.define('tos-conversation', class extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;
      const tabs = [...this.querySelectorAll('[data-conversation-tab]')];
      const select = (tab, focus = false) => {
        tabs.forEach(item => { const active = item === tab; item.setAttribute('aria-selected', String(active)); item.tabIndex = active ? 0 : -1; });
        this.querySelectorAll('[data-conversation-panel]').forEach(panel => { panel.hidden = panel.dataset.conversationPanel !== tab.dataset.conversationTab; });
        if (focus) tab.focus();
      };
      tabs.forEach((tab,index) => {
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); select(tabs[next], true); }
        });
      });
      this.querySelectorAll('[data-conversation-open]').forEach(button => {
        const dialog = document.getElementById(button.dataset.conversationOpen);
        if (!dialog || !dialog.showModal) return;
        button.hidden = false;
        button.addEventListener('click', () => dialog.showModal());
        dialog.querySelector('[data-conversation-close]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', event => { if (event.target === dialog) { const box = dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close(); } });
        const zoom = dialog.querySelector('[data-conversation-zoom]');
        const detail = dialog.querySelector('.tos-conversation__detail');
        const reset = () => { detail.classList.remove('is-zoomed'); zoom.setAttribute('aria-pressed','false'); zoom.textContent = zoom.dataset.zoomLabel; };
        zoom.addEventListener('click', () => { const enlarged = detail.classList.toggle('is-zoomed'); zoom.setAttribute('aria-pressed',String(enlarged)); zoom.textContent = enlarged ? zoom.dataset.resetLabel : zoom.dataset.zoomLabel; if (enlarged) { detail.scrollLeft = (detail.scrollWidth - detail.clientWidth) / 2; detail.scrollTop = (detail.scrollHeight - detail.clientHeight) / 2; } });
        dialog.addEventListener('close', () => { reset(); button.focus(); });
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tos-desktop-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tos-desktop-navigation')) {
    customElements.define('tos-desktop-navigation', class extends HTMLElement {
      connectedCallback() {
        this.disclosures = [...this.querySelectorAll('details')];
        this.onToggle = event => {
          if (event.target.tagName !== 'DETAILS' || !event.target.open) return;
          this.disclosures.forEach(detail => { if (detail !== event.target) detail.open = false; });
        };
        this.onOutside = event => { if (!this.contains(event.target)) this.close(); };
        this.onKey = event => {
          if (event.key !== 'Escape') return;
          const open = this.disclosures.find(detail => detail.open);
          if (open) { event.preventDefault(); open.open = false; open.querySelector('summary').focus(); }
        };
        this.onLink = event => {
          const closeButton = event.target.closest('[data-tos-menu-close]');
          if (closeButton) {
            const detail = closeButton.closest('details');
            detail.open = false;
            detail.querySelector('summary').focus();
            return;
          }
          if (event.target.closest('a[href]')) this.close();
        };
        this.onResize = () => { if (!this.media.matches) this.close(); };
        this.media = matchMedia('(min-width:1100px)');
        this.addEventListener('toggle', this.onToggle, true);
        this.addEventListener('keydown', this.onKey);
        this.addEventListener('click', this.onLink);
        document.addEventListener('click', this.onOutside);
        document.addEventListener('focusin', this.onOutside);
        this.media.addEventListener('change', this.onResize);
      }
      close() { this.disclosures.forEach(detail => { detail.open = false; }); }
      disconnectedCallback() {
        this.removeEventListener('toggle', this.onToggle, true);
        this.removeEventListener('keydown', this.onKey);
        this.removeEventListener('click', this.onLink);
        document.removeEventListener('click', this.onOutside);
        document.removeEventListener('focusin', this.onOutside);
        this.media.removeEventListener('change', this.onResize);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tos-motion"] && !Shopify.designMode) return;
  try {
    (() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  const seen = new WeakSet();
  const mounted = new WeakSet();
  const animations = new Set();
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      if (reduced.matches || document.activeElement && entry.target.contains(document.activeElement)) return;
      const animation = entry.target.animate([{opacity:.25,transform:'translateY(10px)'},{opacity:1,transform:'translateY(0)'}],{duration:480,easing:'cubic-bezier(.2,.65,.3,1)'});
      animations.add(animation);
      animation.finished.then(() => animations.delete(animation)).catch(() => animations.delete(animation));
    });
  },{threshold:.12}) : null;
  reduced.addEventListener('change', () => { if (reduced.matches) animations.forEach(animation => animation.cancel()); });
  function init(root) {
    root.querySelectorAll('.hd-discover .hd-section-head, .hd-archive__heading, .hd-art .hd-section-head, .hd-art__card, .hd-journal .hd-section-head, .hd-visit__image, .hd-visit__copy, .tpm-entry__gallery-section > h2').forEach(element => {
      if (seen.has(element)) return;
      seen.add(element);
      if (observer && !reduced.matches && element.getBoundingClientRect().top > innerHeight) observer.observe(element);
    });
    root.querySelectorAll('[data-rail], [data-press-carousel]').forEach(track => {
      if (mounted.has(track)) return;
      mounted.add(track);
      let start = null;
      let dragged = false;
      const update = () => track.toggleAttribute('data-tos-draggable', fine.matches && track.scrollWidth > track.clientWidth + 3);
      const resize = new ResizeObserver(update);
      resize.observe(track);
      fine.addEventListener('change', update);
      update();
      track.addEventListener('dragstart', event => { if (fine.matches) event.preventDefault(); });
      track.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0 || !track.hasAttribute('data-tos-draggable')) return;
        start = {x:event.clientX,y:event.clientY,left:track.scrollLeft,id:event.pointerId,snap:track.style.scrollSnapType};
        dragged = false;
      });
      track.addEventListener('pointermove', event => {
        if (!start) return;
        const dx = event.clientX - start.x;
        if (!dragged && Math.abs(dx) > 7 && Math.abs(dx) > Math.abs(event.clientY - start.y)) {
          dragged = true;
          track.setPointerCapture(start.id);
          track.style.scrollSnapType = 'none';
          track.setAttribute('data-tos-dragging','');
        }
        if (dragged) { event.preventDefault(); track.scrollLeft = start.left - dx; }
      });
      const finish = () => {
        if (!start) return;
        if (track.hasPointerCapture(start.id)) track.releasePointerCapture(start.id);
        track.style.scrollSnapType = start.snap;
        track.removeAttribute('data-tos-dragging');
        start = null;
        setTimeout(() => { dragged = false; },0);
      };
      track.addEventListener('pointerup', finish);
      track.addEventListener('pointercancel', finish);
      track.addEventListener('lostpointercapture', finish);
      track.addEventListener('pointerleave', () => { if (!dragged) start = null; });
      track.addEventListener('click', event => { if (dragged) { event.preventDefault(); event.stopPropagation(); } },true);
      document.addEventListener('shopify:section:unload', event => { if (event.target.contains(track)) { resize.disconnect(); fine.removeEventListener('change',update); } });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), {once:true});
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tos-trudon-film"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tos-trudon-film')) {
    customElements.define('tos-trudon-film', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.inView = false;
        this.video.muted = true;
        this.video.controls = false;
        this.onVisibility = () => this.syncPlayback();
        this.onMotion = () => this.syncPlayback();
        document.addEventListener('visibilitychange', this.onVisibility);
        this.motion.addEventListener('change', this.onMotion);
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting && entries[0].intersectionRatio >= .3;
          this.syncPlayback();
        }, { threshold: [0, .3] });
        this.observer.observe(this.video);
      }
      syncPlayback() {
        if (this.inView && !document.hidden && !this.motion.matches) {
          this.video.play().then(() => {
            if (!this.isConnected || !this.inView || document.hidden || this.motion.matches) this.video.pause();
          }).catch(() => {});
        } else this.video.pause();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.video?.pause();
        document.removeEventListener('visibilitychange', this.onVisibility);
        this.motion?.removeEventListener('change', this.onMotion);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tos-trudon-opening"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tos-trudon-opening')) {
 customElements.define('tos-trudon-opening', class extends HTMLElement {
  connectedCallback() {
   if(this.ready) return; this.ready=true;
   const tabs=[...this.querySelectorAll('[role="tab"]')];
   const panels=[...this.querySelectorAll('[role="tabpanel"]')];
   const select=(index,focus=false)=>{
    tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;panels[i].hidden=i!==index;});
    if(focus) tabs[index].focus();
   };
   tabs.forEach((tab,index)=>{
    tab.addEventListener('click',()=>select(index));
    tab.addEventListener('keydown',event=>{
     let next;
     if(event.key==='ArrowRight')next=(index+1)%tabs.length;
     if(event.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;
     if(event.key==='Home')next=0;
     if(event.key==='End')next=tabs.length-1;
     if(next!==undefined){event.preventDefault();select(next,true);}
    });
   });
  }
 });
}
  } catch(e) { console.error(e); }
})();

})();
